export default "__VITE_ASSET__SupvIinq__"